import React from "react";
import { Container, Button } from "@material-ui/core";
import {P1, P2, P3} from 'assets/fonts';

export default (props) => {
  return (
    <Container>
      <div
        style={{
          textAlign: "center",
          position: "relative",
          marginTop: "15%",
        }}
      >
        <P1>
          Make sure you're in a quiet place where you can complete the test
          without distraction!
        </P1>
        <Button
          variant="contained"
          size="large"
          style={{ margin: 20, width: 200, color: "white", backgroundColor: "#107896" }}
          onClick={props.onEnvironmentClick}
        >
          OK
        </Button>
      </div>
    </Container>
  );
};
